// @file Composable for remote slideshow controls over Realtime (Brahms)
import { useSlideshowPages } from '@@/vuecomposables/slideshow_pages'

export const useSlideshowRemote = (): {
  handleIncomingGoToSlide: (slideNumber: number) => void
} => {
  const isRenderingSlideshow = (): boolean => {
    try {
      return typeof window !== 'undefined' && window.location?.pathname?.includes('slideshow') === true
    } catch {
      return false
    }
  }

  const handleIncomingGoToSlide = (slideNumber: number): void => {
    if (typeof slideNumber !== 'number' || Number.isNaN(slideNumber)) return
    if (!isRenderingSlideshow()) return
    useSlideshowPages().goToPage(slideNumber)
  }

  return {
    handleIncomingGoToSlide,
  }
}

export default useSlideshowRemote
